import React, { useEffect } from "react";
import { IonDatetime, IonIcon, IonLabel } from "@ionic/react";
import { IEtaProps } from "../../../schemas/StartTrip/StartTrip";
import { LoadStopModel } from "./loadStopUtil";
import { getYearValues } from "../../../utils/formatData";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

const model: LoadStopModel = new LoadStopModel();
export const ETA: React.FunctionComponent<IEtaProps> = (props: IEtaProps) => {
  const eta = model.getETA(props.loadStop);
  const yearValues = getYearValues();
  const isETAReadOnly = model.isETAReadonly(props.loadStop);
  useEffect(() => {
    props.onChange(eta);
  }, [eta, props.shipmentId, props.timestamp]);
  return (
    <React.Fragment>
      <IonLabel className="ETA-label">ETA</IonLabel>
      {props.isWeb ? (
        <div className={`date-picker-web`}>
          <DatePicker
            onChange={(e: Date) => {
              const etaDate = model.getMomentDate(e);
              props.onChange(etaDate);
            }}
            data-testid="datapicker"
            dateFormat="MMM d, yyyy hh:mm aa"
            className={`date-time-picker ${
              isETAReadOnly ? "date-time-picker-disabled" : ""
            }`}
            showTimeSelect
            timeIntervals={5}
            selected={(props.value && new Date(props.value)) || null}
            disabled={isETAReadOnly || props.isNextStop}
          />
          <IonIcon src="assets/icon/calender.svg" className="calender-icon" />
        </div>
      ) : (
        <IonDatetime
          displayFormat="MMM DD hh:mm A"
          pickerFormat="YYYY MMM DD hh:mm A"
          className={`ETA-picker ${
            isETAReadOnly ? "hide-border" : ""
          } execution-field`}
          value={props.value}
          onIonChange={(e) => {
            if (e.detail.value) {
              props.onChange(e.detail.value);
            }
          }}
          yearValues={yearValues}
          minuteValues="00,05,10,15,20,25,30,35,40,45,50,55"
          mode="ios"
          readonly={isETAReadOnly || props.isNextStop}
          disabled={isETAReadOnly || props.isNextStop}
        ></IonDatetime>
      )}
    </React.Fragment>
  );
};
